import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  list: {
    border: `2px solid ${theme.palette.secondary[100]}`,
    borderRadius: '12px',
    '& > *': {
      borderBottom: `2px solid ${theme.palette.secondary[100]} !important`,
    },
    '& > *:first-child': {
      borderTop: 'none !important',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },
    '& > *:last-child': {
      borderBottom: 'none !important',
      borderBottomLeftRadius: '12px',
      borderBottomRightRadius: '12px',
    },
  },
}))
